import React, { useEffect, useRef } from 'react';
import { removeClassFromParent } from '@/utils/dom';
import { Stack } from '@mui/material';
import { Box, BoxProps } from '@mui/material';

export const ImageWithSkeleton = ({ src, alt, ...props }: BoxProps<'img'>) => {
  const ref = useRef<HTMLImageElement>(null);

  const onLoadCallback = (ev: Event) => {
    const element = ev.currentTarget;
    if (!element) return;
    removeClassFromParent(element as HTMLElement, 'skeleton');
  };

  useEffect(() => {
    const img = ref.current;

    if (!img) return;

    if (img.complete) {
      removeClassFromParent(img, 'skeleton');
    } else {
      img.addEventListener('load', onLoadCallback);
    }

    return () => {
      img.removeEventListener('load', onLoadCallback);
    };
  }, [src]);

  return (
    <Stack
      className="skeleton"
      sx={{
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        userSelect: 'none',
      }}
    >
      <Box
        component="img"
        src={src}
        alt={alt}
        loading="lazy"
        ref={ref}
        {...props}
      />
    </Stack>
  );
};
